export default "__VITE_ASSET__B2Ohu005__"